module.exports = __webpack_public_path__ + "img/nav.3c1d912a.png";